import { createContext, useContext, useEffect, useState, useCallback } from "react";

const KEY = "fincalc:a11y:v1";
const defaultPrefs = { dyslexia: false, highContrast: false, largerText: false };

const A11yContext = createContext({ prefs: defaultPrefs, setPref: () => {} });

function readPrefs() {
    try {
        const raw = localStorage.getItem(KEY);
        if (!raw) return defaultPrefs;
        return { ...defaultPrefs, ...JSON.parse(raw) };
    } catch {
        return defaultPrefs;
    }
}

function applyPrefs(prefs) {
    const body = document.body;
    body.classList.toggle("a11y-dyslexia", !!prefs.dyslexia);
    body.classList.toggle("a11y-high-contrast", !!prefs.highContrast);
    body.classList.toggle("a11y-larger", !!prefs.largerText);
    // Larger-text via root font-size bump
    document.documentElement.style.fontSize = prefs.largerText ? "112.5%" : "";
}

export function A11yProvider({ children }) {
    const [prefs, setPrefs] = useState(readPrefs);

    useEffect(() => {
        applyPrefs(prefs);
        try {
            localStorage.setItem(KEY, JSON.stringify(prefs));
        } catch {
            /* ignore */
        }
    }, [prefs]);

    const setPref = useCallback((k, v) => setPrefs((p) => ({ ...p, [k]: v })), []);

    return <A11yContext.Provider value={{ prefs, setPref }}>{children}</A11yContext.Provider>;
}

export function useA11y() {
    return useContext(A11yContext);
}
